import React from "react";
import { Row, Col } from "react-bootstrap";
import "./OptionResults.css";

export default function OptionResults({
  optionText,
  optionPct,
  optionDollar=null,
  optionIcoin=null,
  animateLoad=false,
  color,
  voted,
  filter
}) {
  let cn = "progress-bar";
  let lineheight = '15px';
  let resultBarStyle = {height: '18px', border: 'solid 1px #fcc17d'};
  if (filter === 'raw' || filter === 'weighted') {
    resultBarStyle.height = '24px';
    lineheight = '21px';
  }
  if (voted === true) {
    resultBarStyle.border = 'solid 1px #fa7319';
  }

  let text = optionPct+"%";
  if (optionDollar) text += " ($"+optionDollar+")"
  if (optionIcoin) text = optionIcoin + " i¢";

  const bars = [];
  if (Array.isArray(optionPct)) {
    optionPct.forEach((pct, idx) => {
      bars.push(
        <div key={idx} className="result-bar progress" style={resultBarStyle}> 
          <div 
            role="progressbar" 
            className={cn} 
            aria-valuenow={pct} 
            aria-valuemin="0" 
            aria-valuemax="100" 
            style={{lineHeight: lineheight, width: pct+"%", color: 'white', fontWeight: 'bold', backgroundColor: color[idx], textAlign: 'end', paddingLeft: '1px', paddingRight: '3px'}}
          >
            {pct}%
          </div>
        </div>
      );
    });
  } else {
    bars.push(
      <div className="result-bar progress" style={resultBarStyle}> 
        <div 
          role="progressbar" 
          className={cn} 
          aria-valuenow={optionPct} 
          aria-valuemin="0" 
          aria-valuemax="100" 
          style={{lineHeight: lineheight, width: optionPct+"%", color: 'white', fontWeight: 'bold', backgroundColor: color, textAlign: 'end', paddingLeft: '1px', paddingRight: '3px'}}
        >
          {text}
        </div>
      </div>
    );
  }

  return (
    <div className="option-container">
      <Row className="option-text">
        <Col xs={ optionDollar ? 7 : 12 } style={{letterSpacing: '-0.1px', fontSize: '14px'}}>
          { optionText }
        </Col>
        <Col className="option-pct" xs={ optionDollar ? 5 : 0 }>
          {/* bars.length === 1 ? text : null */}
        </Col>
      </Row>
      {
        animateLoad ? 
          bars.map((bar, idx) => (
            <div key={idx} className="animate-load">
              { bar }
            </div>
          ))
        : bars
      }
    </div>
  );
}